import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faDollarSign } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';
import { formatWithCommas } from '../../../../helpers/formatters/number_formats';
import { connect } from 'react-redux';
import { setOwnedProperties } from './store/actions/owned_properties';

const portfolioValue = (ownedProperties) => {
  return ownedProperties.list.map((ownedProperty) => {
    return ownedProperty.lastSalePrice || 0;
  }).reduce((sum, price) => sum + price, 0);
};

function Portfolio({ contactId, setOwnedProperties, ownedProperties }) {
  useEffect(() => {
    setOwnedProperties(contactId);
  }, []);

  return (
    <Card>
      <Card.Header>
        <h5 className="fw-bolder mb-0">Portfolio Information</h5>
      </Card.Header>
      <Card.Body>
        {ownedProperties.loading && (
          <div className="px-3 py-5">
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          </div>
        )}
        {!ownedProperties.loading && ownedProperties.list.length === 0 && (
          <div className="px-3 py-5">
            <div className="text-center">
              This contact has no properties
            </div>
          </div>
        )}
        {!ownedProperties.loading && ownedProperties.list.length > 0 && (
          <div className="d-flex flex-column gap-6">
            <div className="d-flex gap-4">
              <FontAwesomeIcon icon={faBriefcase} />
              <div>
                <p className="fw-bolder">Portfolio</p>
                <small className="fw-bold">
                  {`${ownedProperties.list.length} ${pluralize('Property', ownedProperties.list.length)} Owned`}
                </small>
              </div>
            </div>
            <div className="d-flex gap-4">
              <FontAwesomeIcon icon={faDollarSign} />
              <div>
                <p className="fw-bolder">Portfolio Assessed Value</p>
                <small className="fw-bold">
                  {`$${formatWithCommas(portfolioValue(ownedProperties))}`}
                </small>
              </div>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

Portfolio.propTypes = {
  contactId: PropTypes.number.isRequired,
  ownedProperties: PropTypes.object,
  setOwnedProperties: PropTypes.func.isRequired
};

const mapStateToProps = ({ ownedProperties }) => ({ ownedProperties });
export default connect(mapStateToProps, { setOwnedProperties })(Portfolio);
